function getActionClass(action) {
  const normalized = String(action ?? "").toUpperCase();
  if (normalized.includes("BUY")) return "action-buy";
  if (normalized.includes("SELL")) return "action-sell";
  if (normalized.includes("AVOID")) return "action-avoid";
  return "action-watch";
}

function getConfidenceClass(confidence) {
  if (!Number.isFinite(confidence)) return "confidence-low";
  if (confidence >= 90) return "confidence-high";
  if (confidence >= 70) return "confidence-medium";
  return "confidence-low";
}

function getTradeabilityClass(status) {
  const normalized = String(status ?? "").toUpperCase();
  if (normalized === "ENTRY_READY") return "tradeability-ready";
  if (normalized === "AVOID_INTRADAY") return "tradeability-avoid";
  if (normalized === "FAILED" || normalized === "STALE") return "tradeability-stale";
  return "tradeability-watch";
}

function formatTradeabilityStatus(status, fallback) {
  const value = status ?? fallback ?? "WATCH_ONLY";
  return String(value).replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}

export default function StockCard({ stock, onSelect, selected }) {
  const price = Number(stock.price);
  const confidence = Number(stock.confidenceScore);
  const score = Number(stock.score);
  const matchedSignals = Number(stock.matchedSignalCount);
  const formattedPrice = Number.isFinite(price)
    ? new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(price)
    : "-";

  const confidenceText = Number.isFinite(confidence) ? confidence.toFixed(0) : stock.confidenceScore ?? "-";
  const scoreText = Number.isFinite(score) ? score.toFixed(0) : stock.score ?? "-";
  const matchedSignalText = Number.isFinite(matchedSignals) ? matchedSignals.toFixed(0) : stock.matchedSignalCount ?? "-";
  const classes = `stock-tile ${getActionClass(stock.action)} ${getConfidenceClass(confidence)}${selected ? " selected" : ""}`;
  const tradeabilityScore = Number(stock.tradeabilityScore);
  const tradeabilityScoreText = Number.isFinite(tradeabilityScore) ? tradeabilityScore.toFixed(0) : "-";
  const tradeabilityClass = getTradeabilityClass(stock.tradeabilityStatus);

  return (
    <button className={classes} type="button" onClick={() => onSelect?.(stock)}>
      <span className="stock-symbol-cell">
        <strong>{stock.symbol}</strong>
        <small>{stock.sector ?? "-"}</small>
      </span>
      <span className="stock-strategy-cell">
        <strong>{stock.strategy ?? "-"}</strong>
        <small>{stock.action ?? "Watch"}</small>
      </span>
      <span className="stock-score-cell">
        <strong>{scoreText}</strong>
        <small>{matchedSignalText} signals</small>
      </span>
      <span className="stock-price">{formattedPrice}</span>
      <span className={`tradeability-pill ${tradeabilityClass}`}>
        {formatTradeabilityStatus(stock.tradeabilityStatus, stock.tradeabilityBucketLabel)}
      </span>
      <span className="stock-tradeability-cell">
        <strong>{tradeabilityScoreText}</strong>
        <small>{stock.liquidityLabel ?? "-"} liq</small>
      </span>
      <span className="stock-tradeability-cell">
        <strong>{stock.volumeTrendLabel ?? "-"}</strong>
        <small>{stock.spreadLabel ?? "-"} spread</small>
      </span>
      <span className="stock-tradeability-cell">
        <strong>{confidenceText}%</strong>
        <small>{stock.lastCheckedAt ? stock.lastCheckedAt.slice(11, 16) : "not checked"}</small>
      </span>
    </button>
  );
}
